export enum KpiType {
  Inventory,
  Time = 1,
  All = 2,
}
